
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const outlinedProps = {
  color: "primary",
  variant: "outlined",
  sx: {},
  downArrowIcon: <ArrowDropDownIcon sx={{ ml: "auto" }} />
};

export const shadowProps = {
  color: "secondary",
  variant: "contained",
  sx: {
    display: "flex",
    gap: "20px",
    padding: "11px 15px",
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.05)",
    fontSize: "14px",
    lineHeight: "normal"
  },
  downArrowIcon: <ExpandMoreIcon />
};